export class AddEditChamberPerkRequest {
    constructor(Value: string, ValidThrough: Date, ValidFrom: Date, Limit: number){
        this.value = Value;
        this.validThrough = ValidThrough;
        this.validFrom = ValidFrom;
        this.limit = Limit;

    }
    value: string;
    validThrough: Date;
    validFrom: Date;
    limit: number;
    perkId: number;
}
